import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_SUCCESS,
  EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
} from "./actionTypes";

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  };
};

export const userForgetPasswordSuccess = (message) => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const userForgetPasswordError = (message) => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  };
};

//EMAIL_PASSWORD_RESET_TOKEN_VALIDATION
export const emailPasswordResetTokenValidation = (token) => {
  return {
    type: EMAIL_PASSWORD_RESET_TOKEN_VALIDATION,
    payload: token,
  };
};

export const emailPasswordResetTokenValidationSuccess = (response) => {
  return {
    type: EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_SUCCESS,
    payload: response,
  };
};

export const emailPasswordResetTokenValidationError = (response) => {
  return {
    type: EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_ERROR,
    payload: response,
  };
};

//CHANGE_PASSWORD
export const changePassword = (data) => {
  return {
    type: CHANGE_PASSWORD,
    payload: data,
  };
};

export const changePasswordSuccess = (response) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: response,
  };
};

export const changePasswordError = (response) => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: response,
  };
};
